<template lang="html">
  <transition name='fade'>
    <section class="wcc reset section" v-if="show" v-hammer:press="reset" @touchstart.prevent="start" @mousedown="start" mouseleave="cancel" @touchend="cancel" @mouseup="cancel" @mouseup.prevent="cancel">
      <div class="wcc progress" :class="{animate: held}"></div>
      <span class="wcc progress-label">Hold to Reset</span>
    </section>
  </transition>
</template>
<script>
  import calculatorData from '@/models';
  export default {
    data() {
      return {
        held: false,
        originalCalculatorDataDefaults: ''
      }
    },
    methods: {
      start() {
        this.held = true
      },
      cancel() {
        this.held = false
      },
      reset() {
        this.$store.state.calculatorDataDefaults = this.originalCalculatorDataDefaults
        this.$store.state.calculatorsData = [new calculatorData(true)]
        this.held = false
      }
    },
    computed: {
      show() {
        let calculatorsData = this.$store.state.calculatorsData
        for (let index in calculatorsData) {
          if (calculatorsData[index].price.value > 0) {
            return true
          } else if (calculatorsData[index].buyingAgentCommission.value != '') {
            return true
          } else if (calculatorsData[index].listingGrossCommissions.value != '') {
            return true
          }
        }
        return false
      },
    },
    mounted() {
      // make sure it doesn't affect the object in vuex
      this.originalCalculatorDataDefaults = JSON.parse(JSON.stringify(this.$store.state.calculatorDataDefaults))
    }
  }
</script>
<style lang="scss">

  @keyframes increment {
    from {width: 0%;}
    to {width: 100%;}
  }

  .wcc.reset {
    background-color: $grey-400;
    text-align: center;
    position: relative;
    height: $spacing * 3.123;
    overflow: hidden;
    cursor: pointer;
    .wcc.progress {
      width: 0%;
      height: 100%;
      background-color: $red;
      pointer-events: none;
      &.animate {
        animation-name: increment;
        animation-duration: 2s;
      }
    }
    .wcc.progress-label {
      position: absolute;
      color: white;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      text-align: center;
      line-height: 4em;
      pointer-events: none;
    }
  }

</style>